module.exports = __webpack_public_path__ + "static/media/Colizeum_5_t.9cb22dee.jpg";